module.exports = __webpack_public_path__ + "static/media/Slide6.83aab1b7.png";